/**
 * Our own no operation function to avoid using one from another library.
 *
 * @author Ryan Johnston <ryan.johnston@scalesology.com>
 */
const noop = () => {};

export default noop;
